import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { requestPasswordReset } from "../api/auth";
import "./password-reset.css";

export const PasswordResetRequest = (): JSX.Element => {
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(null);
        setSuccess(false);
        setIsLoading(true);

        try {
            await requestPasswordReset(email);
            setSuccess(true);
            setEmail("");
        } catch (err: any) {
            setError(
                err.response?.data?.message ||
                err.message ||
                "An error occurred. Please try again."
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="password-reset-container">
            <div className="password-reset-card">
                <div className="password-reset-header">
                    <h1>Reset Password</h1>
                    <p className="password-reset-subtitle">
                        Enter your email address and we'll send you a password reset link
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="password-reset-form">
                    {error && (
                        <div className="password-reset-error" role="alert">
                            {error}
                        </div>
                    )}

                    {success && (
                        <div className="password-reset-success" role="alert">
                            If an account with that email exists, a password reset link has
                            been sent. Please check your email.
                        </div>
                    )}

                    <div className="password-reset-field">
                        <label htmlFor="email">Email Address</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            required
                            autoComplete="email"
                            disabled={isLoading || success}
                        />
                    </div>

                    <button
                        type="submit"
                        className="password-reset-button"
                        disabled={isLoading || success}
                    >
                        {isLoading ? "Sending..." : "Send Reset Link"}
                    </button>
                </form>

                <div className="password-reset-link">
                    <Link to="/login">Back to Login</Link>
                </div>
            </div>
        </div>
    );
};